import { i18n } from 'localization'
import { parseDate } from './utils'

export default class ClinicalEpisode {
	static fromJSON(json) {
		if (!json) return null
		return new ClinicalEpisode(json.state, json.date, json.lastEpisode)
			.withDate(json.date)
			.withEpisodeNumber(json.episodeNumber || 0)
			.withTitle(
				json.episodeNumber || 0,
				json.firstEpisode,
				json.lastEpisode
			)
	}

	constructor(state, date, lastEpisode) {
		this.id = `${state?.name || ''}_${date}`
		this.isLastEpisode = lastEpisode
	}

	withEpisodeNumber(episodeNumber) {
		this.episodeNumber = episodeNumber
		return this
	}

	withDate(dateStr) {
		this.date = parseDate(dateStr || '')
		return this
	}

	withTitle(index, isFirst, isLast) {
		if (isLast) {
			this.title = i18n`Last episode`
		} else if (isFirst) {
			this.title = i18n`Initial episode`
		} else {
			this.title = i18n`Episode ${index + 1}`
		}
		return this
	}
}
